import { updateLinksAttributes } from '../utils/handleAttributes';

export default function footerGallery() {
  const widgetName = 'footerGallery';
  const widgetOpts = footerGalleryOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createfooterGallery(data.items, $widget);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });
}

function createfooterGallery(widgetData, $widget) {
  if (widgetData.length === 1) {
    $widget.addClass('single-item');
  }
  $widget.find('.card-widget-item').each(function (x) {
    const { Title, ImageWithPath, URL } = widgetData[x];
    const $galleryItem = $(this);

    $galleryItem.replaceWith(`
        <a ${URL == null || URL === '' ? '' : 'href="' + URL + '"'} class="gallery-item${URL == null || URL === '' ? ' void' : ''}" ${updateLinksAttributes(URL, Title)}>
          <img class="card-widget-image lozad" src="${ImageWithPath}" data-src="${ImageWithPath}" alt="${Title}" data-loaded="true" alt="${Title}">
          <div class="overlay"></div>
        </a>
        `);

    updateLinksAttributes(URL, Title, $galleryItem);
  });
}
